import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from 'screens/components/basic/Grid';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import moment from 'moment';
import Pagination from 'screens/components/basic/Pagination';
import { getMonthlyProductSales, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { reportMonthlyProductSalesCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import WithRouter from 'custom/withRouter';
import PageHeader from 'screens/components/basic/PageHeader';

class MonthlySales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0,
            model: {
                year: 0,
                branch: 0
            }
        };
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date.getFullYear(), `MonthlyProductSalesYear`);
    }

    getReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let branch = this.props.branch || this.props.loggedBranch;

        this.props.getMonthlyProductSales({ year, pageNumber, pageSize, branch });
    }

    downloadReport = () => {
        let branch = this.props.branch || this.props.loggedBranch;
        let year = this.props.year || moment().format('YYYY');
        this.props.getCsvReport(`reports/excel/MonthlyProductSales?year=${year}&branchId=${branch}&pageNumber=1&pageSize=20`, "MonthlyProductSales");
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`MonthlyProductSalesYear`);
        this.props.clearFormInput(`MonthlyProductSalesBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        let totalRows = (this.props.monthlyProductSales ? this.props.monthlyProductSales.length > 0 ? this.props.monthlyProductSales[0].totalrow : 0 : 0);
        return (
            <Grid headerContent={reportMonthlyProductSalesCrumb}>
                <PageHeader title={LOOKUP.report.monthlyProductSales.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-monthly-product-sales-report" />}
                    description={LOOKUP.report.monthlyProductSales.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch}
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                />
                <p className="text-right mt-2 mr-2">
                    <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                </p>
                <CardSimple>
                    <Body monthlyProductSales={this.props.monthlyProductSales} searchedYear={this.props.year} />
                    <Pagination
                        length={totalRows}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={this.changePage}
                    />
                </CardSimple>
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        monthlyProductSales: state.reports.monthlyProductSales,
        loggedBranch: state.common.branchId,
        year: state.form.MonthlyProductSalesYear,
        branch: state.form.MonthlyProductSalesBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMonthlyProductSales: model => dispatch(getMonthlyProductSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(MonthlySales));